import styled, { createGlobalStyle } from "styled-components";
import { device } from "../commons/util/helperFunctions";
import { getAppConfig } from "../commons/util/appConfigHelper";

export const GlobalStyles = createGlobalStyle`
  :root {
    --body-primary: ${({ theme }) => theme.primary};
    --body-primary-foreground: ${({ theme }) => theme.primaryForeground};
    --body-primary-hover: ${({ theme }) => theme.primaryHover};

    --body-secondary: ${({ theme }) => theme.secondary};
    --body-secondary-foreground: ${({ theme }) => theme.secondaryForeground};
    --body-secondary-hover: ${({ theme }) => theme.secondaryHover};

    --body-tertiary: ${({ theme }) => theme.tertiary};
    --body-tertiary-foreground: ${({ theme }) => theme.tertiaryForeground};
    --body-tertiary-hover: ${({ theme }) => theme.tertiaryHover};

    --background: ${({ theme }) => theme.background};
    --foreground: ${({ theme }) => theme.foreground};

    --input-primary: ${({ theme }) => theme.input};
    --border-primary: ${({ theme }) => theme.border};

    --text-action: ${({ theme }) => theme.text?.actionTextColor};

    --text-black200: ${({ theme }) => theme.text?.black200};
    --text-black300: ${({ theme }) => theme.text?.black300};
    --text-black800: ${({ theme }) => theme.text?.black800};
    --text-black900: ${({ theme }) => theme.text?.black900};

    --text-gray200: ${({ theme }) => theme.text?.gray200};
    --text-gray300: ${({ theme }) => theme.text?.gray300};
    --text-gray400: ${({ theme }) => theme.text?.gray400};
    --text-gray500: ${({ theme }) => theme.text?.gray500};
    --text-gray900: ${({ theme }) => theme.text?.gray900};

    --text-white900: ${({ theme }) => theme.text?.white900};

    --button-primarybackground: ${({ theme }) => theme.button?.primaryBackground};
    --button-primarytext: ${({ theme }) => theme.button?.primaryText};

    --page-background-primary: ${({ theme }) => theme.pageBackground?.primary};
    --page-background-secondary: ${({ theme }) => theme.pageBackground?.secondary};
    --section-background: ${({ theme }) => theme.section?.background};

    --primary-font: ${({ theme }) => theme.font?.primary};
    --font-secondary: ${({ theme }) => theme.font?.secondary};
    --font-fallback: ${({ theme }) => theme.font?.fallback};
    --text-primary: ${({ theme }) => theme.text?.primaryText};
  }

  p {
    margin: 0;
    padding: 0;
  }
`;

export const Button = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  background-color: transparent;
`;

export const StyledButton = styled.button`
  border: none;
  background-color: transparent;
`;

export const UnorderedList = styled.ul`
  margin: 0;
  padding: 0;
`;

export const PrimaryButtonAdilx = styled(StyledButton)`
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  border-radius: 100px;
  width: ${({ width }) => width || "100%"};
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ? backgroundColor : theme?.button?.primaryBackground};
  border: ${({ border }) => (border ? border : "none")};
  color: ${({ color, theme }) => (color ? color : theme?.button?.primaryText)};
  padding: 18px;
  border-radius: 100px;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  font-family: ${({ theme }) => theme?.font?.primary};
  text-transform: ${() => getAppConfig("CTA_TEXT_CASE") === "SentenceCase" ? "none" : "uppercase"};
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};

  @media ${device.laptop} {
    &:hover {
      opacity: 0.7;
    }
  }
`;

export const PrimaryButton = styled(StyledButton)`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ isTemplateTwo }) => (isTemplateTwo ? "fit-content" : "100%")};

  background-color: ${({ isloginScreen, theme }) =>
    isloginScreen ? "#C8A776" : theme?.button?.primaryBackground};

  color: ${({ isloginScreen, theme }) =>
    isloginScreen ? "black" : theme?.button?.primaryText};

  border-radius: ${({ isAdTheme }) => (isAdTheme ? "0px" : "100px")};
  cursor: pointer;
  font-weight: 800;
  font-size: 16px;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  padding: ${({ isTemplateTwo }) =>
    isTemplateTwo ? "10px 30px" : "12px 40px"};
  border: ${({ isTemplateTwo }) => isTemplateTwo && "none"};

  @media ${device.laptop} {
    &:hover {
      opacity: ${({ isTemplateTwo, noOpactiy }) =>
        isTemplateTwo || noOpactiy ? 1 : 0.7};
      background-color: ${({ isTemplateTwo, theme }) =>
        isTemplateTwo
          ? theme?.colors?.button?.hover
          : theme?.colors?.button?.primaryBackground};
    }
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  background-color: ${({ theme }) => theme?.background};
  color: ${({ theme }) => theme?.primary};
  border: 1.7px solid ${({ theme }) => theme?.primary};
`;

export const TertiaryButton = styled(PrimaryButton)`
  background-color: ${({ theme }) => theme?.background};
  color: ${({ theme }) => theme?.primary};
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;

  min-width: ${({ isAdTheme }) => (isAdTheme ? "160px" : "auto")};
  font-weight: ${({ isAdTheme }) => (isAdTheme ? "600" : "bold")};
  font-size: ${({ isAdTheme }) => (isAdTheme ? "16px" : "14px")};
  gap: ${({ isAdded }) => (isAdded ? "16px" : "0")};

  background-color: ${({ theme }) => theme?.button?.primaryBackground};
  border: ${({ isAdTheme, isTemplateTwo, theme }) =>
    isAdTheme || isTemplateTwo ? "none" : `2px solid ${theme?.primary}`};

  border-radius: 100px;
  cursor: pointer;
  color: ${({ isTemplateTwo, theme }) =>
    isTemplateTwo
      ? theme?.colors?.secondary
      : theme?.button?.primaryText};

  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  text-transform: ${() => getAppConfig("CTA_TEXT_CASE") === "SentenceCase" ? "none" : "uppercase"};

  @media ${device.laptop} {
    font-size: ${({ isAdTheme }) => (isAdTheme ? "16px" : "14px")};
    text-transform: ${() => getAppConfig("CTA_TEXT_CASE") === "SentenceCase" ? "none" : "uppercase"};

    &:hover {
      opacity: ${({ isTemplateTwo  }) => (isTemplateTwo ? 1 : 0.7)};
      background-color: ${({ isTemplateTwo, theme }) =>
        isTemplateTwo
          ? theme?.colors?.button?.hover
          : theme?.colors?.button?.primaryBackground};
    }
  }
`;
export const H1 = styled.h1`
  margin: 0;
  font-size: 36px;
  color: ${({ theme }) => theme?.text?.black200};
  font-family:
    ${({ theme }) => theme?.font?.secondary},
    ${({ theme }) => theme?.font?.fallback};

  @media ${device.laptop} {
    font-size: 63px;
  }
`;

export const H2 = styled.h2`
  margin: 0;
  font-size: 28px;
  color: ${({ theme }) => theme?.text?.black200};
  font-family:
    ${({ theme }) => theme?.font?.secondary},
    ${({ theme }) => theme?.font?.fallback};

  @media ${device.laptop} {
    font-size: 56px;
  }
`;

export const H3 = styled.h3`
  margin: 0;
  font-size: 24px;
  color: ${({ theme }) => theme?.text?.black200};
  font-family:
    ${({ theme }) => theme?.font?.secondary},
    ${({ theme }) => theme?.font?.fallback};

  @media ${device.laptop} {
    font-size: 48px;
  }
`;

export const H4 = styled.h4`
  margin: 0;
  font-size: 22px;
  color: ${({ theme }) => theme?.text?.black200};
  font-family:
    ${({ theme }) => theme?.font?.secondary},
    ${({ theme }) => theme?.font?.fallback};

  @media ${device.laptop} {
    font-size: 40px;
  }
`;

export const H5 = styled.h5`
  margin: 0;
  font-size: 20px;
  color: ${({ theme }) => theme?.text?.black200};
  font-family:
    ${({ theme }) => theme?.font?.secondary},
    ${({ theme }) => theme?.font?.fallback};

  @media ${device.laptop} {
    font-size: 32px;
  }
`;

export const H6 = styled.h6`
  margin: 0;
  font-size: 18px;
  color: ${({ theme }) => theme?.text?.black200};
  font-family:
    ${({ theme }) => theme?.font?.secondary},
    ${({ theme }) => theme?.font?.fallback};

  @media ${device.laptop} {
    font-size: 26px;
  }
`;

export const T1 = styled.p`
  margin: 0;
  font-size: 20px;
  color: ${({ theme }) => theme?.text?.black200};
  font-family:
    ${({ theme }) => theme?.font?.primary},
    ${({ theme }) => theme?.font?.fallback};

  @media ${device.laptop} {
    font-size: 24px;
  }
`;

export const T2 = styled(T1)`
  font-size: 18px;

  @media ${device.laptop} {
    font-size: 22px;
  }
`;

export const T3 = styled(T1)`
  font-size: 16px;

  @media ${device.laptop} {
    font-size: 20px;
  }
`;

export const T4 = styled(T1)`
  font-size: 14px;

  @media ${device.laptop} {
    font-size: 18px;
  }
`;

export const T5 = styled(T1)`
  font-size: 12px;

  @media ${device.laptop} {
    font-size: 16px;
  }
`;

export const B1 = styled(T1)`
  font-size: 10px;

  @media ${device.laptop} {
    font-size: 14px;
  }
`;

export const B2 = styled(T1)`
  font-size: 8px;

  @media ${device.laptop} {
    font-size: 12px;
  }
`;

export const P = styled.p`
  margin: 0;
  font-family:
    ${({ theme }) => theme?.font?.primary},
    ${({ theme }) => theme?.font?.fallback};
`;
export const GeneralPageWrapper = styled.section`
  background-color: #ffffff;
  padding: 0 24px;

  @media ${device.tablet} {
    padding: 0 48px;
  }

  @media ${device.laptop} {
    padding: 0 72px;
  }

  @media ${device.laptopL} {
    padding: 0 136px;
  }
  @media ${device.desktop} {
    padding: 0 272px;
  }
`;

export const HorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background: #d9d9d9;
`;

export const SpacedOutRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const Image = styled.img``;

export const Bold = styled.b`
  font-family: ManropeBold;
`;

export const ExtraBold = styled.b`
  font-family: ManropeExtraBold;
`;

export const Link = styled.a`
  color: ${({ color }) => color || "#273135"};

  &:hover,
  &:visited,
  &:active {
    color: ${({ color }) => color || "#273135"};
  }
`;

export const SVG = styled.svg``;
